import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { getCursor, writeData } from './db';
import { appConfig } from '../config/app-config';
import { IRNSummaryDetails } from '../common/types';
import { MisSummaryEntity } from '../common/entity';
import {
  CursorAccess,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  MIS_SUMMARY_INDEX,
  QueryType,
} from './constants';

const isEqualIRNData = (
  oldData: MisSummaryEntity,
  newData: IRNSummaryDetails
): boolean => {
  const oldIRNData: IRNSummaryDetails = {
    totalNoOfInvoices: oldData.totalNoOfInvoices,
    totalPendingIrnGeneration: oldData.totalPendingIrnGeneration,
    totalIrnGenerated: oldData.totalIrnGenerated,
    totalIrnFailed: oldData.totalIrnFailed,
    totalIrnCancelled: oldData.totalIrnCancelled,
  };
  return isEqual(oldIRNData, newData);
};

export const getMisSummary = async (
  invoiceStartDate: string,
  invoiceEndDate: string,
  orgId: string
): Promise<MisSummaryEntity | undefined> => {
  try {
    const startDate = moment(invoiceStartDate, DATE_TIME_FORMAT);
    const endDate = moment(invoiceEndDate, DATE_TIME_FORMAT);
    let cursor = await getCursor(
      appConfig.IDB.STORE.MIS_SUMMARY,
      MIS_SUMMARY_INDEX.ORG_ID_INDEX.NAME,
      orgId,
      CursorAccess.READ_ONLY,
      QueryType.ONLY
    );

    while (cursor) {
      if (
        moment(cursor.value.invoiceStartDate).format(DATE_FORMAT) ===
          startDate.format(DATE_FORMAT) &&
        moment(cursor.value.invoiceEndDate).format(DATE_FORMAT) ===
          endDate.format(DATE_FORMAT)
      ) {
        return cursor.value;
      }
      // eslint-disable-next-line no-await-in-loop
      cursor = await cursor.continue();
    }
  } catch (e) {
    // console.log('Failed to get MIS Summary from db', e);
  }
};

export const createOrUpdateMisSummary = async (
  invoiceStartDate: string,
  invoiceEndDate: string,
  orgId: string,
  summary: IRNSummaryDetails
) => {
  try {
    const startDate = moment(invoiceStartDate, DATE_TIME_FORMAT);
    const endDate = moment(invoiceEndDate, DATE_TIME_FORMAT);
    let cursor = await getCursor(
      appConfig.IDB.STORE.MIS_SUMMARY,
      MIS_SUMMARY_INDEX.ORG_ID_INDEX.NAME,
      orgId,
      CursorAccess.READ_WRITE,
      QueryType.ONLY
    );

    while (cursor) {
      if (
        moment(cursor.value.invoiceStartDate).format(DATE_FORMAT) ===
          startDate.format(DATE_FORMAT) &&
        moment(cursor.value.invoiceEndDate).format(DATE_FORMAT) ===
          endDate.format(DATE_FORMAT)
      ) {
        if (isEqualIRNData(cursor.value, summary)) return;
        const updatedData = Object.assign(cursor.value, summary);
        // @ts-ignore
        cursor.update(updatedData);
        return;
      }
      cursor = await cursor.continue();
    }
    const misSummary: MisSummaryEntity = {
      invoiceStartDate: startDate.toDate(),
      invoiceEndDate: endDate.toDate(),
      orgId,
      ...summary,
    };
    await writeData(appConfig.IDB.STORE.MIS_SUMMARY, misSummary);
  } catch (e) {
    // console.log('Failed to write data to idb', e);
  }
};
